import api from './api';
import {
  BuscarUsuarioDTO,
  SolicitudAmistadDTO,
  AmistadDTO,
  EnviarSolicitudAmistadDTO
} from '../types/amigos';

export class AmigosService {
  /**
   * Busca usuarios por username o nombre
   */
  static async buscarUsuarios(query: string): Promise<BuscarUsuarioDTO[]> {
    const response = await api.get<BuscarUsuarioDTO[]>('/api/amistades/buscar', {
      params: { q: query }
    });
    return response.data;
  }

  /**
   * Envía una solicitud de amistad
   */
  static async enviarSolicitud(destinatarioId: number): Promise<SolicitudAmistadDTO> {
    console.log('📤 [SERVICE] Preparando solicitud');
    console.log('   - destinatarioId:', destinatarioId);
    const dto: EnviarSolicitudAmistadDTO = { usuarioDestinatarioId: destinatarioId };
    console.log('   - DTO a enviar:', dto);
    const response = await api.post<SolicitudAmistadDTO>('/api/amistades/solicitudes/enviar', dto);
    console.log('   - Respuesta recibida:', response.data);
    return response.data;
  }

  /**
   * Obtiene las solicitudes recibidas pendientes
   */
  static async obtenerSolicitudesRecibidas(): Promise<SolicitudAmistadDTO[]> {
    const response = await api.get<SolicitudAmistadDTO[]>('/api/amistades/solicitudes/recibidas');
    return response.data;
  }

  /**
   * Obtiene las solicitudes enviadas pendientes
   */
  static async obtenerSolicitudesEnviadas(): Promise<SolicitudAmistadDTO[]> {
    const response = await api.get<SolicitudAmistadDTO[]>('/api/amistades/solicitudes/enviadas');
    return response.data;
  }

  /**
   * Acepta una solicitud de amistad
   */
  static async aceptarSolicitud(solicitudId: number): Promise<AmistadDTO> {
    const response = await api.post<AmistadDTO>(`/api/amistades/solicitudes/${solicitudId}/aceptar`);
    return response.data;
  }

  /**
   * Rechaza una solicitud de amistad
   */
  static async rechazarSolicitud(solicitudId: number): Promise<void> {
    await api.post(`/api/amistades/solicitudes/${solicitudId}/rechazar`);
  }

  /**
   * Cancela una solicitud enviada
   */
  static async cancelarSolicitud(solicitudId: number): Promise<void> {
    await api.delete(`/api/amistades/solicitudes/${solicitudId}/cancelar`);
  }

  /**
   * Obtiene el contador de solicitudes pendientes
   */
  static async contarSolicitudesPendientes(): Promise<number> {
    const response = await api.get<{ count: number }>('/api/amistades/solicitudes/pendientes/contar');
    return response.data.count;
  }

  /**
   * Obtiene la lista de amigos
   */
  static async obtenerAmigos(): Promise<AmistadDTO[]> {
    const response = await api.get<AmistadDTO[]>('/api/amistades/amigos');
    return response.data;
  }

  /**
   * Elimina una amistad por el id de la fila Amistad (no por el id del usuario amigo).
   */
  static async eliminarAmistad(amistadId: number): Promise<void> {
    await api.delete(`/api/amistades/${amistadId}`);
  }

  /**
   * Verifica si dos usuarios son amigos
   */
  static async verificarAmistad(usuarioId: number): Promise<boolean> {
    const response = await api.get<{ sonAmigos: boolean }>(`/api/amistades/verificar/${usuarioId}`);
    return response.data.sonAmigos;
  }
}
